import { useEffect, useState } from "react";
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./Components/Theme/theme";

import "./App.css";
// --------------------------------------------------------------------------------------------------------------------------------------------------------------------

import AdminErrorPage from "./Components/Suspense/AdminErrorPage";
import Loader from "./Components/Suspense/Loader";

// --------------------------------------------------------------------------------------------------------------------------------------------------------------------

import NavbarSidebarLayoutAdmin from "./Components/NavBar/NavbarSidebarLayoutAdmin";
import NavbarSidebarLayoutCandidate from "./Components/NavBar/NavbarSidebarLayoutCandidate";
import NavbarSidebarLayoutClient from "./Components/NavBar/NavbarSidebarLayoutClient";

import LoginPage from "./Views/Login/LoginPage";

// Admin  -------------------------------------------------------------------------------------------------------------------------------------------------------------

import AdminDashboard from "./Components/Dashboard/AdminDashboard";

import AddClient from "./Views/Clients/AddClient";
import EditClients from "./Views/Clients/EditClients";
import ListClients from "./Views/Clients/ViewClient";
import ClientDetails from "./Views/Clients/ClientDetails";
import ClientFieldPrivilege from "./Views/Role/ClientFieldPrivilege";

import AddStaff from "./Views/Staff/AddStaff";
import EditStaff from "./Views/Staff/EditStaff";
import ListStaff from "./Views/Staff/ListStaff";
import StaffDetails from "./Views/Staff/StaffDetails";

import AddCandidate from "./Views/Candidate/AddCandidate";
import EditCandidate from "./Views/Candidate/EditCandidate";
import ListCandidate from "./Views/Candidate/ListCandidate";
import CandidateProfile from "./Views/Candidate/CandidateProfile";

import Privilege from "./Views/Role/Privilege";

import AddRole from "./Views/Role/AddRole";
import EditRole from "./Views/Role/EditRole";
import ListRole from "./Views/Role/ListRole";

import AuditLog from "./Components/Audit/Audit";

import Profile from "./Components/Dashboard/Profile";

import Settings from "./Components/Settings/Settings";
import OtherSetting from "./Components/Settings/OtherSetting";

import NotificationsPage from "./Views/Notifications/Notification";

import CreateJob from "./Views/Jobs/CreateJob";
import EditJob from "./Views/Jobs/EditJob";
import JobDetails from "./Views/Jobs/JobDetails";
import JobListing from "./Views/Jobs/JobListing";

import CreateJobLinking from "./Views/JobLinking/CreateJobLinking";
import EditJobLinking from "./Views/JobLinking/EditJobLinking";

import AddProfession from "./Views/Lookups/AddLookups/AddProfession";
import EditProfession from "./Views/Lookups/EditLookups/EditProfession";
import ProfessionList from "./Views/Lookups/ViewLookups/ProfessionList";

import AddQualification from "./Views/Lookups/AddLookups/AddQualification";
import EditQualification from "./Views/Lookups/EditLookups/EditQualification";
import QualificationList from "./Views/Lookups/ViewLookups/QualificationList";

import AddRecruitmentCountry from "./Views/Lookups/AddLookups/AddRecruitmentCountry";
import EditRecruitmentCountry from "./Views/Lookups/EditLookups/EditRecruitmentCountry";
import RecruitmentCountryList from "./Views/Lookups/ViewLookups/RecruitmentCountryList";

import AddDesignation from "./Views/Lookups/AddLookups/AddDesignation";
import EditDesignation from "./Views/Lookups/EditLookups/EditDesignation";
import DesignationList from "./Views/Lookups/ViewLookups/DesignationList";

import AddEmploymentType from "./Views/Lookups/AddLookups/AddEmploymentType";
import EmploymentTypeList from "./Views/Lookups/ViewLookups/EmploymentTypeList";
import EditEmploymentType from "./Views/Lookups/EditLookups/EditEmploymentType";

import CompanyTypeList from "./Views/Lookups/ViewLookups/CompanyTypeList";
import EditCompanyType from "./Views/Lookups/EditLookups/EditCompanyType";
import AddCompanyType from "./Views/Lookups/AddLookups/AddCompanyType";

import AddDocument from "./Views/Lookups/AddLookups/AddDocument";
import EditDocument from "./Views/Lookups/EditLookups/EditDocument";
import DocumentList from "./Views/Lookups/ViewLookups/DocumentList";

import AddBranch from "./Views/Lookups/AddLookups/AddBranch";
import EditBranch from "./Views/Lookups/EditLookups/EditBranch";
import BranchList from "./Views/Lookups/ViewLookups/BranchList";

import AddDepartment from "./Views/Lookups/AddLookups/AddDepartment";
import DepartmentList from "./Views/Lookups/ViewLookups/DepartmentList";
import EditDepartment from "./Views/Lookups/EditLookups/EditDepartment";

import SalaryPayList from "./Views/Lookups/ViewLookups/SalaryPayList";
import AddSalaryPay from "./Views/Lookups/AddLookups/AddSalaryPay";
import EditSalaryPay from "./Views/Lookups/EditLookups/EditSalaryPay";

import AddCurrency from "./Views/Lookups/AddLookups/AddCurrency";
import EditCurrency from "./Views/Lookups/EditLookups/EditCurrency";
import CurrencyList from "./Views/Lookups/ViewLookups/CurrencyList";

import YearsOfExperienceList from "./Views/Lookups/ViewLookups/YearsOfExperienceList";
import EditYearsOfExperience from "./Views/Lookups/EditLookups/EditYearsOfExperience";
import AddYearsOfExperience from "./Views/Lookups/AddLookups/AddYearsOfExperience";

import AdditionalRequirementList from "./Views/Lookups/ViewLookups/AdditionalRequirementList";
import EditAdditionalRequirements from "./Views/Lookups/EditLookups/EditAdditionalRequirements";
import AddAdditionalRequirements from "./Views/Lookups/AddLookups/AddAdditionalRequirements";

import AddRecruitmentProcedure from "./Views/ProcessFlow/RecruitmentProcedure/AddRecruitmentProcedure";
import CloneRecruitmentProcedure from "./Views/ProcessFlow/RecruitmentProcedure/CloneRecruitmentProcedure";
import RecruitmentProcedureList from "./Views/ProcessFlow/RecruitmentProcedure/RecruitmentProcedureList";
import ViewRecruitmentProcedure from "./Views/ProcessFlow/RecruitmentProcedure/ViewRecruitmentProcedure";

import RecruitmentProcedureMappingList from "./Views/ProcessFlow/RecruitmentProcedureMapping/RecruitmentProcedureMappingList";
import AddRecruitmentProcedureMapping from "./Views/ProcessFlow/RecruitmentProcedureMapping/AddRecruitmentProcedureMapping";
import EditRecruitmentProcedureMapping from "./Views/ProcessFlow/RecruitmentProcedureMapping/EditRecruitmentProcedureMapping";
import ViewRecruitmentProcedureMapping from "./Views/ProcessFlow/RecruitmentProcedureMapping/ViewRecruitmentProcedureMapping";

import AddDocumentProcedure from "./Views/ProcessFlow/DocumentProcedure/AddDocumentProcedure";
import EditDocumentProcedure from "./Views/ProcessFlow/DocumentProcedure/EditDocumentProcedure";
import DocumentProcedureList from "./Views/ProcessFlow/DocumentProcedure/DocumentProcedureList";

import Reports from "./Views/Reports/Report";

// Candidate-----------------------------------------------------------------------------------------------------------------------------------------------------------
import CandidateDash from "./CandidateView/Dashboard/CandidateDash";
import CandidateNotifications from "./CandidateView/Notifications/CandidateNotifications";
import CandidateProfilePage from "./CandidateView/CandidateProfile/CandidateProfilePage";
import CandidateJobs from "./CandidateView/Dashboard/CandidateJobs";
import CandidateSummary from "./CandidateView/Dashboard/CandidateSummary";

// Client--------------------------------------------------------------------------------------------------------------------------------------------------------------
import ClientDash from "./ClientView/Dashboard/ClientDash";
import ClientJobList from "./ClientView/Jobs/ClientJobList";
import ClientJobDetails from "./ClientView/Jobs/ClientJobDetails";
import ClientJobApplicantList from "./ClientView/Jobs/ClientJobApplicantList";
import ClientCandidateList from "./ClientView/Candidate/ClientCandidateList";
import ClientCandidateProfile from "./ClientView/Candidate/ClientCandidateProfile";
import DeployedClientCandidateList from "./ClientView/Candidate/DeployedClientCandidateList";
import ClientProfilePortal from "./ClientView/ClientProfile/ClientProfilePortal";

// --------------------------------------------------------------------------------------------------------------------------------------------------------------------

const AdminComponents = () => {
  return (
    <NavbarSidebarLayoutAdmin>
      <Routes>
        {/* Admin Dashboard */}
        <Route path="/" element={<AdminDashboard />} />

        {/* Client CRUD */}
        <Route path="/Clients" element={<ListClients />} />
        <Route path="/Clients/Add" element={<AddClient />} />
        <Route path="/Clients/Edit/:id" element={<EditClients />} />
        <Route path="/Clients/View/:id" element={<ClientDetails />} />

        {/* Staff CRUD */}
        <Route path="/Staffs" element={<ListStaff />} />
        <Route path="/Staffs/Add" element={<AddStaff />} />
        <Route path="/Staffs/Edit/:id" element={<EditStaff />} />
        <Route path="/Staffs/View/:id" element={<StaffDetails />} />

        {/* Candidate CRUD */}
        <Route path="/Candidates" element={<ListCandidate />} />
        <Route path="/Candidates/Add" element={<AddCandidate />} />
        <Route path="/Candidates/Edit/:id" element={<EditCandidate />} />
        <Route path="/Candidates/View/:id" element={<CandidateProfile />} />

        {/* Job CRUD */}
        <Route path="/Jobs" element={<JobListing />} />
        <Route path="/Jobs/Add" element={<CreateJob />} />
        <Route path="/Jobs/Edit/:id" element={<EditJob />} />
        <Route path="/Jobs/View/:id" element={<JobDetails />} />
        <Route path="/Jobs/Applicants/:id" element={<ClientJobApplicantList/>} />

        {/* Reports */}
        <Route path="/Reports" element={<Reports />} />

        {/* Jobs Linking CRUD */}
        <Route path="/JobLinking/Add/:id" element={<CreateJobLinking />} />
        <Route path="/JobLinking/Edit/:id" element={<EditJobLinking />} />

        {/* Process Flow */}
        {/* Recruitment Procedure */}
        <Route path="/RecruitmentProcedure" element={<RecruitmentProcedureList />}/>
        <Route path="/RecruitmentProcedure/Add" element={<AddRecruitmentProcedure />}/>
        <Route path="/RecruitmentProcedure/Clone/:id" element={<CloneRecruitmentProcedure />}/>
        <Route path="/RecruitmentProcedure/View/:id" element={<ViewRecruitmentProcedure />}/>

        {/* Recruitment Procedure Mapping */}
        <Route path="/RecruitmentMappingProcedure" element={<RecruitmentProcedureMappingList />}/>
        <Route path="/RecruitmentMappingProcedure/Add" element={<AddRecruitmentProcedureMapping />}/>
        <Route path="/RecruitmentMappingProcedure/Edit/:id" element={<EditRecruitmentProcedureMapping />}/>
        <Route path="/RecruitmentMappingProcedure/View/:id" element={<ViewRecruitmentProcedureMapping />}/>

        {/* Document Procedure */}
        <Route path="/DocumentProcedure" element={<DocumentProcedureList />} />
        <Route path="/DocumentProcedure/Add" element={<AddDocumentProcedure />}/>
        <Route path="/DocumentProcedure/Edit/:pid/:cid" element={<EditDocumentProcedure />}/>

        {/* Roles and Privilages */}
        <Route path="/Roles" element={<ListRole />} />{/* API Integrated - 13-05-25*/} {/* Cryptography Implemented */}
        <Route path="/Roles/Add" element={<AddRole />} />{/* API Integrated - 13-05-25*/}
        <Route path="/Roles/Edit/:id" element={<EditRole />} />{/* API Integrated - 13-05-25*/} {/* Cryptography Implemented */}

        <Route path="/Privileges" element={<Privilege />} />
        <Route path="/ClientPrivileges" element={<ClientFieldPrivilege />} />

        {/* Lookups */}
        <Route path="/ProfessionLookup" element={<ProfessionList />} /> {/* API Integrated -14-05-25*/} {/* Cryptography Implemented */}
        <Route path="/ProfessionLookup/Add" element={<AddProfession />} /> {/* API Integrated -14-05-25*/}
        <Route path="/ProfessionLookup/Edit/:id" element={<EditProfession />}/> {/* API Integrated -14-05-25*/} {/* Cryptography Implemented */}

        <Route path="/QualificationLookup" element={<QualificationList />}/> {/* API Integrated - 15-05-25*/} {/* Cryptography Implemented */}
        <Route path="/QualificationLookup/Add" element={<AddQualification />}/> {/* API Integrated - 15-05-25*/}
        <Route path="/QualificationLookup/Edit/:id" element={<EditQualification />}/> {/* API Integrated - 15-05-25*/} {/* Cryptography Implemented */}

        <Route path="/DesignationLookup" element={<DesignationList />} /> {/* API Integrated - 15-05-25*/} {/* Cryptography Implemented */}
        <Route path="/DesignationLookup/Add" element={<AddDesignation />}/> {/* API Integrated - 15-05-25*/}
        <Route path="/DesignationLookup/Edit/:id" element={<EditDesignation />}/> {/* API Integrated - 15-05-25*/} {/* Cryptography Implemented */}

        <Route path="/EmploymentTypeLookup" element={<EmploymentTypeList />}/> {/* API Integrated - 16-05-25 */} {/* Cryptography Implemented */}
        <Route path="/EmploymentTypeLookup/Add" element={<AddEmploymentType />}/> {/* API Integrated - 16-05-25 */}
        <Route path="/EmploymentTypeLookup/Edit/:id" element={<EditEmploymentType />}/> {/* API Integrated - 16-05-25 */} {/* Cryptography Implemented */}

        <Route path="/DocumentLookup" element={<DocumentList />} /> {/* API Integrated - 16-05-25*/} {/* Cryptography Implemented */}
        <Route path="/DocumentLookup/Add" element={<AddDocument />} /> {/* API Integrated - 16-05-25*/}
        <Route path="/DocumentLookup/Edit/:id" element={<EditDocument />}/> {/* API Integrated - 16-05-25*/} {/* Cryptography Implemented */}
        
        <Route path="/CompanyTypeLookup" element={<CompanyTypeList />} /> {/* API Integrated - 16-05-25 */} {/* Cryptography Implemented */}
        <Route path="/CompanyTypeLookup/Add" element={<AddCompanyType />}/> {/* API Integrated - 16-05-25*/}
        <Route path="/CompanyTypeLookup/Edit/:id" element={<EditCompanyType />}/> {/* API Integrated - 16-05-25*/} {/* Cryptography Implemented */}

        <Route path="/RecruitmentCountryLookup" element={<RecruitmentCountryList />}/> {/* API Integrated - 19-05-25*/} {/* Cryptography Implemented */}
        <Route path="/RecruitmentCountryLookup/Add" element={<AddRecruitmentCountry />}/> {/* API Integrated - 19-05-25*/}
        <Route path="/RecruitmentCountryLookup/Edit/:id" element={<EditRecruitmentCountry />}/> {/* API Integrated - 19-05-25*/} {/* Cryptography Implemented */}

        <Route path="/BranchLookup" element={<BranchList />} /> {/* API Integrated - 20-05-25*/} {/* Cryptography Implemented */}
        <Route path="/BranchLookup/Add" element={<AddBranch />} /> {/* API Integrated - 20-05-25*/}
        <Route path="/BranchLookup/Edit/:id" element={<EditBranch />} /> {/* API Integrated - 20-05-25*/} {/* Cryptography Implemented */}

        <Route path="/DepartmentLookup" element={<DepartmentList />} /> {/* API Integrated - 20-05-25*/} {/* Cryptography Implemented */}
        <Route path="/DepartmentLookup/Add" element={<AddDepartment />} /> {/* API Integrated - 20-05-25*/}
        <Route path="/DepartmentLookup/Edit/:id" element={<EditDepartment />}/> {/* API Integrated - 20-05-25*/} {/* Cryptography Implemented */}

        <Route path="/AdditionalRequirementsLookup" element={<AdditionalRequirementList />}/> {/* API Integrated - 21-05-25*/} {/* Cryptography Implemented */}
        <Route path="/AdditionalRequirementsLookup/Add" element={<AddAdditionalRequirements />}/> {/* API Integrated - 21-05-25*/}
        <Route path="/AdditionalRequirementsLookup/Edit/:id" element={<EditAdditionalRequirements />}/> {/* API Integrated - 21-05-25*/} {/* Cryptography Implemented */}

        <Route path="/SalaryPayLookup" element={<SalaryPayList />} /> {/* API Integrated - 21-05-25*/} {/* Cryptography Implemented */}
        <Route path="/SalaryPayLookup/Add" element={<AddSalaryPay />} /> {/* API Integrated - 21-05-25*/}
        <Route path="/SalaryPayLookup/Edit/:id" element={<EditSalaryPay />}/> {/* API Integrated - 21-05-25*/} {/* Cryptography Implemented */}

        <Route path="/YearsOfExperienceLookup" element={<YearsOfExperienceList />}/> {/* API Integrated - 22-05-25*/} {/* Cryptography Implemented */}
        <Route path="/YearsOfExperienceLookup/Add" element={<AddYearsOfExperience />}/> {/* API Integrated - 22-05-25*/}
        <Route path="/YearsOfExperienceLookup/Edit/:id" element={<EditYearsOfExperience />}/> {/* API Integrated - 22-05-25*/} {/* Cryptography Implemented */}

        <Route path="/CurrencyLookup" element={<CurrencyList />} />
        <Route path="/CurrencyLookup/Add" element={<AddCurrency />} />
        <Route path="/CurrencyLookup/Edit/:id" element={<EditCurrency />} />

        {/* Settings */}
        <Route path="/SystemSettings" element={<Settings />} />
        <Route path="/GeneralSettings" element={<OtherSetting />} />

        {/* Audit Log */}
        <Route path="/AuditLog" element={<AuditLog />} />

        {/* Notifications */}
        <Route path="/Notifications" element={<NotificationsPage />} />

        {/* Profile */}
        <Route path="/Profile" element={<Profile />} />

        {/* Error Routing */}
        <Route path="/*" element={<AdminErrorPage />} />
      </Routes>
    </NavbarSidebarLayoutAdmin>
  );
};

const CandidateComponents = () => {
  return (
    <NavbarSidebarLayoutCandidate>
      <Routes>
        <Route path="/" element={<CandidateDash />} />

        <Route path="/Jobs" element={<CandidateJobs/>}/>
        <Route path="/Notifications" element={<CandidateNotifications />} />
        <Route path="/Summary" element={<CandidateSummary />} />

        <Route path="/Profile" element={<CandidateProfilePage />} />

        <Route path="/*" element={<AdminErrorPage />} />
      </Routes>
    </NavbarSidebarLayoutCandidate>
  );
};

const ClientComponents = () => {
  return (
    <NavbarSidebarLayoutClient>
      <Routes>
        <Route path="/" element={<ClientDash/>} />
        <Route path="/Jobs" element={<ClientJobList/>} />
        <Route path="/Jobs/View/:id" element={<ClientJobDetails/>} />
        <Route path="/Jobs/Applicants/:id/:title" element={<ClientJobApplicantList/>} />

        <Route path="/Candidates" element={<ClientCandidateList/>} />
        <Route path="/Candidates/View" element={<ClientCandidateProfile/>} />
        
        <Route path="/DeployedCandidates" element={<DeployedClientCandidateList/>} />

        <Route path="/Profile" element={<ClientProfilePortal/>} />
        <Route path="/*" element={<AdminErrorPage />} />
      </Routes>
    </NavbarSidebarLayoutClient>
  );
};

function App() {
  const [role, setRole] = useState(null);
  const [loadContent, setLoadContent] = useState(false);

  useEffect(() => {
    const storedRole = localStorage.getItem("SWA_userRole") || sessionStorage.getItem("SWA_userRole"); // admin | client | candidate | null
    setRole(storedRole); // admin | client | candidate | null
    setLoadContent(true);
  }, []);

  if (!loadContent) return <Loader />;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <ToastContainer />
        <Routes>

          <Route path="/Login" element={<LoginPage setRole={setRole} loginUser={`candidate`}/>} />
          <Route path="/Login/Admin" element={<LoginPage setRole={setRole} loginUser={`admin`}/>}/>
          <Route path="/Login/Client" element={<LoginPage setRole={setRole} loginUser={`client`}/>}/>
          <Route
            path="/*"
            element={
              role == "candidate" ? (
                <CandidateComponents />
              ) : role == "client" ? (
                <ClientComponents />
              ) : role == "admin" ? (
                <AdminComponents />
              ) : (
                <Navigate to="/Login" />
              )
            }
          />
          
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
